import hardtack from 'hardtack';

import { translitText, serializeObject, debounce, isMobileDevice } from '@utilities';

import _inviteBanner from './templates/invite-banner.hbs';

import inviteLanding from './images';

const COOKIE_NAME = 'ochkovnet_testnabor';
const TITLE = '[data-title="title"]';
const INVITE_BANNER_CLOSE = '[data-handle="inviteBannerClose"]';
const STICKY_HEADER = '.l-header__wrapper';

const MATCH_MEDIA = '(max-width: 960px)';
const DELAY = 1000;
const SPEED = 750;

export default class InviteBanner {
    constructor(context) {
        this.context = context;

        if (this.context.innerHTML) return;

        const { id } = this.context.dataset;

        let session;
        const cookie = hardtack.get(COOKIE_NAME);

        try {
            session = sessionStorage.getItem(COOKIE_NAME);
        } catch (error) {
            console.error(error);
        }

        if (cookie || session) {
            this.context.remove();
        }

        this.id = id;
        this.url = window.location.href;
        this.matchMedia = window.matchMedia(MATCH_MEDIA);

        this.render(inviteLanding);
    }

    setFloatingBanner = () => {
        const banner = this.context;
        const main = document.querySelector('body');

        const stickyHeader = document.querySelector(STICKY_HEADER).offsetHeight;
        const vieportCenter = Math.floor(document.documentElement.clientHeight / 2);
        const scrollHeight = window.pageYOffset;
        const distanceToTop =
            vieportCenter + scrollHeight - Math.floor(banner.offsetHeight / 2) - stickyHeader;
        const bannerPosY = banner.getBoundingClientRect().top + scrollHeight;

        const upperBound = Math.floor(main.offsetHeight / 5);
        const bottomBound = Math.floor(main.offsetHeight / 2.1);
        const middleBound = upperBound + (bottomBound - upperBound) / 2;

        const travelDistance = Math.abs(distanceToTop - bannerPosY);
        const time = (travelDistance / SPEED).toFixed(3);

        if (distanceToTop > upperBound && distanceToTop < bottomBound) {
            banner.style.transition = `top ${time}s ease-in-out, opacity 3000ms`;
            banner.style.top = `${distanceToTop}px`;
            banner.style.opacity = 1;
        } else {
            banner.style.top = `${distanceToTop > middleBound ? bottomBound : upperBound}px`;
            banner.style.opacity = 0;
        }
    };

    // eslint-disable-next-line class-methods-use-this
    setCookie() {
        hardtack.set(COOKIE_NAME, '1', {
            maxAge: 31536000,
        });
    }

    clearStyle = () => {
        setTimeout(() => {
            this.context.removeAttribute('style');
        }, DELAY + 25);
    };

    render(object) {
        const { image, retina, url } = object;

        const content = document.querySelector(TITLE);
        const title = content ? content.innerHTML : '';

        const utm = serializeObject({
            utm_source: 'inlink',
            utm_medium: 'banner',
            utm_campaign: window.location.pathname.slice(1).replace(/\/$/, '').replace(/\//g, '-'),
            utm_content: translitText(title.replace(/[!-,?]|^\s*|\s*$/g, '').toLowerCase()),
        });

        const href = `${url}?${utm}`;

        this.context.innerHTML = _inviteBanner({
            image: {
                original: image,
                retina,
            },
            href,
        });

        sessionStorage.setItem(COOKIE_NAME, 1);
        this.setCookie();

        this.context.querySelector(INVITE_BANNER_CLOSE).addEventListener('click', () => {
            this.context.remove();
        });

        const observer = debounce(this.setFloatingBanner, DELAY, true);

        if (!this.matchMedia.matches && !isMobileDevice) {
            window.addEventListener('scroll', observer);
        }

        this.matchMedia.addEventListener('change', ({ matches }) => {
            this.clearStyle();

            // eslint-disable-next-line no-unused-expressions
            !matches && !isMobileDevice
                ? window.addEventListener('scroll', observer)
                : window.removeEventListener('scroll', observer);
        });
    }
}
